





















































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import FormsGlobal from '../../mixins/FormsGlobal';
import { Logic, Form, FormRow } from "../../models/Form";
import ProjectProposalUploadFiles from '../ProjectProposal/ProjectProposalUploadFiles.vue';
import { TranslateResult } from "vue-i18n";

@Component({
  components: {
    ProjectProposalUploadFiles
  }
})
export default class TdocFields extends Vue {
  @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
  @Prop({ type: Object, required: true }) rows!: { [key: string]: FormRow };
  @Prop({ type: String }) tip!: string;
  @Prop({ type: Function }) onClick!: Function;
  @Prop({ type: String }) currentTitle!: string;
  @Prop({ type: Boolean }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isError!: boolean;
  @Prop({ type: Boolean }) isRequired!: boolean;
  @Prop({ type: Object }) item!: Form;
  @Prop({ type: Number }) totalFiles!: number;
  @Prop({ type: Boolean }) fileUpload!: boolean;
  processedRows = new Set<string>();

  get filteredSortedRows() {
    return FormsGlobal.filteredSortedRows(this.rows, this.processedRows).filter(row => !this.isRowHidden(row));
  }

  get isComponentError(): boolean {
    return Object.values(this.rows).some((row: FormRow) => row.rowCode);
  }

  get hasStyledChildRows() {    
    return this.filteredSortedRows.some(row => row.styleJson );
  }
  getFieldClasses(row: FormRow) {
    let mobileWidth = '100';
    let desktopWidth = '100';

    if (row.styleJson) {
      try {
        const style = JSON.parse(row.styleJson);
        if (Array.isArray(style) && style.length > 0) {
          mobileWidth = style[0].mobile || '100';
          desktopWidth = style[0].desktop || '100';
        }
      } catch (error) {
        console.error('Error parsing styleJson:', error);
      }
    }

    return {
      'w-full': mobileWidth === '100',
      'w-1/2': mobileWidth === '50',
      'md:w-full': desktopWidth === '100',
      'md:w-1/2': desktopWidth === '50',
    };
  }

  isParent(row: FormRow): boolean {
    return row.isParent || false;
  }

  getComponent(type: string, isParent: boolean) {
    return FormsGlobal.getComponent(type, isParent);
  }

  evaluateExpressionLogic(expressionLogic: Logic[]) {
    if (!expressionLogic || !Array.isArray(expressionLogic)) return true;

    return expressionLogic.every((logic: Logic) => {
      const targetRow = this.rows[logic.id_riga];
      if (!targetRow) return true;
      const valueToCheck = logic.value.toLowerCase();
      switch (logic.type) {
        case 'boolean':
          return targetRow.valCheck === null && (logic.value === 'true');
        case 'contain':
          return (targetRow.valText && targetRow.valText.toLowerCase().includes(valueToCheck)) ||
                 (targetRow.valCombo && targetRow.valCombo.toLowerCase().includes(valueToCheck));
        case 'empty':
          return !targetRow.valText;
        default:
          return true;
      }
    });
  }

  isRowOutcome(row: FormRow, outcome: 'disable' | 'hide' | 'show'): boolean {
    let expressionLogic: Logic[] = [];
    try {
      expressionLogic = JSON.parse(row.expressionLogic);
    } catch (error) {
      console.error('Error parsing expressionLogic:', error);
    }
    if (Array.isArray(expressionLogic)) {
      return expressionLogic.some((logic: Logic) => {
        return logic.outcome === outcome && this.evaluateExpressionLogic([logic]);
      });
    }
    return false;
  }

  isRowDisabled(row: FormRow) {
    return row.disabled === true || this.isRowOutcome(row, 'disable');
  }

  isRowHidden(row: FormRow) {
    if (!row.expressionLogic) {
      return false; // Show by default if there is no expression logic
    }

    const showOutcome = this.isRowOutcome(row, 'show');
    const hideOutcome = this.isRowOutcome(row, 'hide');

    if (hideOutcome) {
      return true; // Hide if the hide condition is met
    }

    if (!showOutcome && row.expressionLogic.includes('"outcome": "show"')) {
      return true; // Hide if there is a show condition and it is not met
    }

    return false; // Otherwise, show the row
  }


 
}
